// Field knowledge for CompletedWorkout_v3 and the Workout_v3 it points at.
// Semantics follow the backend's data model notes
// (MySwimPro-backend/CLAUDE.md, "Data Model: pool length").
import { getStrokeString, getPoolCourseString } from '../Utils'
import { EMPTY, formatNumber } from '../Shared/detailFormat'

const METERS_TO_YARDS = 1.09361

// totalDistance is stored in display units. The workout's own pool says which;
// a workout without a usable pool falls back to the legacy course enum.
export const isYardsWorkout = (completedWorkout) => {
  const pool = completedWorkout.get('pool') || completedWorkout.get('workout')?.get('pool')
  if (typeof pool?.isDisplayInYards === 'boolean' && typeof pool?.distanceInMeters === 'number') {
    return pool.isDisplayInYards
  }
  return completedWorkout.get('poolCourse') === 0
}

// `pool` is canonical and always in meters. It can be an empty subdocument,
// and distanceInMeters === 0 means "no pool": often open water, but a pool
// swim whose length was never set looks the same.
export const describePool = (pool) => {
  if (!pool || typeof pool.distanceInMeters !== 'number') {
    return null
  }
  if (pool.distanceInMeters === 0) {
    return 'No pool length (0)'
  }
  const text = pool.isDisplayInYards
    ? `${formatNumber(pool.distanceInMeters * METERS_TO_YARDS, 2)} yd`
    : `${formatNumber(pool.distanceInMeters, 2)} m`
  return text + (pool.isDefault ? ' (member default)' : '')
}

export const describePoolCourse = (poolCourse) =>
  poolCourse === undefined || poolCourse === null
    ? EMPTY
    : getPoolCourseString(poolCourse)

// totalDistanceByStroke / totalDurationByStroke are indexed by stroke.
export const byStrokeRows = (distances, durations) => {
  const length = Math.max(distances?.length || 0, durations?.length || 0)
  const rows = []
  for (let stroke = 0; stroke < length; stroke++) {
    const distance = distances?.[stroke] || 0
    const duration = durations?.[stroke] || 0
    if (distance > 0 || duration > 0) {
      rows.push({ stroke, label: getStrokeString(stroke), distance, duration })
    }
  }
  return rows
}

// A GPS track is the only reliable open-water signal on a completed workout.
export const hasGpsTrack = (completedWorkout) =>
  (completedWorkout.get('locationSamples') || []).length > 0
